/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Importing_ContentsInputs */



/**
* | output |
* | --- |
* | "Importing contents..." |
*
* @param {Importing_ContentsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const importing_contents = /** @type {((inputs?: Importing_ContentsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Importing_ContentsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation du contenu...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Inhalte werden importiert...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione dei contenuti...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт содержимого...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importando contenidos...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在导入内容……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("コンテンツをインポートしています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सामग्री आयात की जा रही है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importando conteúdo...")
	return /** @type {LocalizedString} */ ("Importing contents...")
});